<div class="flex justify-center items-center min-h-screen w-full">
    <div class="flex flex-col w-full max-w-full">
        <app-logo [logo]="logo" />
        <h1 class="text-center pt-8 mb-8 font-semibold sm:text-3xl text-2xl text-wrap">{{noJobId}}</h1>
    </div>
</div>
